exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/** Colors */\n/** FlatUI Color Palette\n*\n*\tColor names based on FlatUI: https://flatuicolors.com/\n*/\n/** Acrylic Color Palette\n*\n*\tColor names based on Name that Color: http://chir.ag/projects/name-that-color\n*/\n.help-popover {\n  display: inline-block;\n  height: 100%;\n  line-height: 100%;\n  color: #0067cb; }\n\n.help-popover-trigger {\n  cursor: pointer; }\n\n.help-popover-container {\n  max-width: 250px;\n  padding: 0 .2rem;\n  text-align: left; }\n  .help-popover-container p {\n    margin-bottom: 0; }\n", ""]);

// exports
